<div class="p-3 pb-0 pt-2 h-100">
    <div class="d-flex align-items-center mb-2" [trvTooltip]="nvdbNavigation.toolTipTextLastFeatureUpdate" [position]="toolTipPositions">
        <app-svg-icon style="fill: #1e5c88" [svgIcon]="circleInfoIcon"></app-svg-icon>
        <span style="font-style: italic; margin-left: 0.5rem">
            @if (environment.application == 'NjdbPåWebb') {
                @if (nvdbNavigation.loadingformattedLastFeatureUpdateNVDB) {
                    {{ 'Laddar datum när NJDB uppdaterades...' }}
                } @else {
                    {{
                        nvdbNavigation.formattedLastFeatureUpdateNVDB
                            ? 'Data uttaget från NJDB: ' + nvdbNavigation.formattedLastFeatureUpdateNVDB
                            : 'Kunde inte hämta datum då NJDB uppdaterades'
                    }}
                }
                <span class="ms-4" [trv-loading]="nvdbNavigation.loadingformattedLastFeatureUpdateNVDB"></span>
            }
            @if (environment.application == 'JNBKarta') {
                <span class="hej">{{ selectedYearText }}</span>
            }
        </span>
    </div>

   
    @if (environment.application == 'JNBKarta' && trvMapService.isMapLoaded()) {
        <div>
            <trv-select
                class="mb-3"
                [disableClear]="true"
                [formControl]="nvdbNavigation.searchMenuState.yearObject"
                [source]="nvdbNavigation.availableYearSearchFilter"
                placeholder="2024"
                valueKey="displayYear"
                [displayMethod]="displayYearObject"
            ></trv-select>
        </div>
    }

    <div
        class="h-100"
        (keydown.arrowDown)="handleFocusKeys($event, FocusKey.ARROW_DOWN)"
        (keydown.arrowUp)="handleFocusKeys($event, FocusKey.ARROW_UP)"
        (keydown.enter)="handleFocusKeys($event, FocusKey.ENTER)"
    >
        @if (environment.application == 'JNBKarta' && trvMapService.isMapLoaded()) {
            <div class="mb-4">
                <app-dataslag-tree></app-dataslag-tree>
            </div>
            <hr />
        }

        @if (environment.application == 'NjdbPåWebb') {
            <div class="d-flex mb-3 align-items-center">
                <div class="input-group me-2">
                    <input
                        [formControl]="dataslagSearch"
                        type="search"
                        class="form-control"
                        placeholder="Sök dataprodukt"
                        aria-label="Sök dataprodukt"
                        aria-describedby="button-addon2"
                    />

                    <button class="btn btn-primary search-btn" type="button" id="button-addon2">
                        <app-svg-icon [svgIcon]="searchIcon"></app-svg-icon>
                        <span class="visually-hidden">Sök</span>
                    </button>
                </div>

                <div class="form-check show_choosen_checkbox_container">
                    <input type="checkbox" class="form-check-input" [formControl]="showChoosenDataslag" id="showChoosenDataslag" />
                    <label
                        class="form-check-label"
                        for="showChoosenDataslag"
                        [trvTooltip]="
                            numberOfDataProdukterActive() +
                            ' ' +
                            (numberOfDataProdukterActive() === 1
                                ? lang.GetValue('Layerlist.ShowChoosen')
                                : lang.GetValue('Layerlist.ShowChoosenPlural'))
                        "
                    >
                        {{ lang.GetValue('MapMenu.Selected') }}
                    </label>
                </div>
                <button
                    type="button"
                    class="p-2 btn-close"
                    aria-label="Close"
                    [trvTooltip]="'Släck alla dataprodukter'"
                    (click)="disableAllLayers()"
                ></button>
            </div>

            <div class="mb-2">
                <trv-form>
                    <trv-select
                        [formControl]="njdbFilters"
                        [source]="njdbDataslagsFilters"
                        valueKey="id"
                        [displayMethod]="displayObjectNjdbFilter"
                        [disableClear]="true"
                    ></trv-select>
                </trv-form>
            </div>

            <div
                class="c-datatypes"
                [ngClass]="{ mobile: nvdbNavigation.isMobileDevice }"
                (scroll)="onScrollEvent($event)"
                #scrollContainer
                [trv-loading]="!trvMapService.isMapLoaded()"
            >
                @if (filteredDataslagLayers.length == 0) {
                    <div>Inga dataprodukter hittades.</div>
                }
                @for (layer of filteredDataslagLayers; track layer; let index = $index) {
                    <div
                        class="form-check c-datatypes__datatype dataslag-item"
                        [ngClass]="{
                            'c-datatypes__datatype_programaticallyHovered': currentlyFocusedDataslagNumber == index,
                        }"
                        (contextmenu)="onRightClick($event, layer)"
                    >
                        <input
                            type="checkbox"
                            class="form-check-input"
                            [id]="layer.layerName! + layer.id"
                            [value]="layer.id"
                            (change)="tmpOnWmsLayerInputChange($event, layer, index)"
                            [checked]="layerActive(layer)"
                        />
                        <label
                            class="form-check-label no-select width-100"
                            [ngClass]="{
                                'data-slag-not-visible-on-zoomlevel': getTrvMap()!.needToZoomInOnLayer(layer),
                            }"
                            [for]="layer.layerName! + layer.id"
                        >
                            {{ layer.name }}
                        </label>
                        <div class="c-datatypes__handle">
                            @if (layer.type == 'wms' && layer.getCapabilitiesStatus) {
                                @if (!(layer.getCapabilitiesStatus == 'Done' || layer.getCapabilitiesStatus == 'Error')) {
                                    <button
                                        class="btn btn-outline-secondary c-datatypes__btn"
                                        [trvTooltip]="'Lagerinformation laddas'"
                                        [position]="toolTipPositions"
                                        [trv-loading]="true"
                                    >
                                        <span class="visually-hidden fix">Lagerinformation laddas</span>
                                    </button>
                                }

                                @if (layer.getCapabilitiesStatus == 'Error') {
                                    <button
                                        class="btn btn-outline-secondary c-datatypes__btn bug"
                                        [trvTooltip]="'Ett fel skedde vid hämtning av lagerdata'"
                                        [position]="toolTipPositions"
                                    >
                                        <app-svg-icon [svgIcon]="svgWarning"></app-svg-icon>
                                        <span class="visually-hidden fix">Lagerinformation laddas</span>
                                    </button>
                                }
                            }

                            @if (getTrvMap()!.needToZoomInOnLayer(layer)) {
                                <button
                                    class="btn btn-outline-secondary c-datatypes__btn"
                                    (click)="zoomToLayer(layer)"
                                    [trvTooltip]="'Zooma till 1:' + layer.maxScaleDenominator + ' för att se lagret'"
                                    [position]="toolTipPositions"
                                >
                                    <app-svg-icon [svgIcon]="searchIconPlusFilled"></app-svg-icon>
                                    <span class="visually-hidden fix">Zooma till</span>
                                </button>
                            }

                            <button
                                class="btn btn-outline-secondary c-datatypes__btn"
                                (click)="infoAboutLayer(layer)"
                                [trvTooltip]="'Visa information om lagret'"
                                [position]="toolTipPositions"
                            >
                                <app-svg-icon [svgIcon]="infoIcon"></app-svg-icon>
                                <span class="visually-hidden fix">Om Dataprodukt</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
